/*
* Created on Thu Oct 12 2023 10:28:00 AM
*
* ***************************************************************************************
* Copyright (c) AVPS Technologies Inc 2023 
*
* All Rights Reserved
* Unpublished rights are reserved under the copyright laws of the United States.
* The software contained in this media is proprietary to and embodies confidential
* the technology of AVPS Technologies Inc. Possession, use, duplication or
* dissemination of the software and media is authorized only pursuant to a valid
* written license from AVPS Technologies Inc.
*
* The above copyright notice and this permission notice shall be included in
* all copies or substantial portions of the Software.
*
* RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
* is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
* 252.227-7013 or in FAR 52.227-19, as applicable.
****************************************************************************************
*/
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './api/reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// ==============================|| REDUX - MAIN STORE ||============================== //

// Middleware
const middleware = [thunk];

// Persist config
const persistConfig = {
    key: 'root',
    storage,
    // Company, branch, and selected-product state are tenant-bound and must be
    // rebuilt after the hostname-scoped SiteContext resolves. Persisting them
    // here was the source of stale cross-domain Redux snapshots.
    whitelist: ['auth'],
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, reducer);


const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(...middleware))
);


// Create the persistor
const persister = persistStore(store);

export { store, persister };

